import { cn } from '@/lib/utils';
import { Template } from '../types';
import { useCreateTemplate } from '../api/templates';


type Props = {
  template: Template;
  onSelectTemplate: () => void;
  className?: string;
}

const TemplateCard = ({ template, className }: Props) => {

  const { createTemplate } = useCreateTemplate(template.template_id)

  return (
    <div
      onClick={() => createTemplate(template.template_id)}
      className={cn(
        "group relative w-full h-full bg-gradient-to-b from-purple-300 to-violet-100 p-3 rounded-2xl overflow-hidden shadow-template hover:shadow-template-hover transition-all duration-300 cursor-pointer transform hover:-translate-y-1",
        className
      )}
    >
      {/* Image Section */}
      <div className="relative w-full aspect-square rounded-xl bg-card-header overflow-hidden">
        <img
          src={template.image_url}
          alt={template.template_name}
          className="w-full h-full object-cover transition-transform duration-300 rounded-xl"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/10" />
      </div>

      {/* Content Section */}
      <div className="h-32 bg-card-footer px-3 pt-4 flex flex-col justify-between">
        <div>
          <h3 className="text-card-footer-foreground font-semibold text-lg leading-tight mb-2 line-clamp-1 font-montserrat tracking-wide">
            {template.template_name.replace("_", " ")}
          </h3>
          <p className="text-card-footer-foreground/80 text-sm font-poppins tracking-wide text-gray-500">
            {template.template_description}
          </p>
        </div>
        
      </div>
    </div>
  );
};

export default TemplateCard;
